var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUserMenuIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.5c-5.524 0-10 4.476-10 10s4.476 10 10 10 10-4.476 10-10-4.476-10-10-10zm0 3.871a3.548 3.548 0 110 7.097 3.548 3.548 0 010-7.097zm0 13.87a7.727 7.727 0 01-5.907-2.75c.758-1.427 2.242-2.41 3.972-2.41.096 0 .193.016.286.044.524.17 1.072.278 1.649.278s1.129-.109 1.65-.278a.987.987 0 01.285-.044c1.73 0 3.214.983 3.972 2.41A7.727 7.727 0 0112 20.242z",
    fill: "#777"
  })));
}

export default SvgUserMenuIcon;